import React from 'react';





const DataOnDocumentsTab = (props) => {

    



    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
       
       DataOnDocumentsTab

        </div>
    );
};

export default DataOnDocumentsTab;